import { render } from "./AuroraView.vue?vue&type=template&id=21219a76"
import script from "./AuroraView.vue?vue&type=script&lang=js"
export * from "./AuroraView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__